// JQuery中拿来的一些方法
let class2type = {}
let toString = class2type.toString
let hasOwn = class2type.hasOwnProperty
let getProto = Object.getPrototypeOf
let fnToString = hasOwn.toString
let ObjectFunctionString = fnToString.call(Object)

const isPlainObject = (obj) => {
  let proto, Ctor

  // Detect obvious negatives
  if (!obj || Object.prototype.toString.call(obj) !== '[object Object]') {
    return false
  }
  proto = getProto(obj)

  // Objects with no prototype (e.g., `Object.create( null )`) are plain
  if (!proto) {
    return true
  }

  // Objects with prototype are plain iff they were constructed by a global Object function
  Ctor = hasOwn.call(proto, "constructor") && proto.constructor

  return typeof Ctor === 'function' && fnToString.call(Ctor) === ObjectFunctionString
}

const type = obj => {
  if (obj == null) {
    return obj + ''
  }

  // Support: Android <=2.3 only (functionish RegExp)
  return typeof obj === 'object' || typeof obj === 'function' ?
    class2type[Object.prototype.toString.call(obj)] || 'object' :
    typeof obj
}

export {
  isPlainObject,
  type
}